export enum DOCUMENT_PURPOSES {
  SUPPORTING_DOCUMENT = "SUPPORTING_DOCUMENT",
  SETTLEMENT_DOCUMENT = "SETTLEMENT_DOCUMENT",
  INTERNAL_DOCUMENT = "INTERNAL_DOCUMENT",
  GENERATED = "GENERATED",
  GENERATED_ESIGN = "GENERATED_ESIGN",
}
